export const selectOptionsMaritalStatus = ["Married", "Not Married"];
